import { Component, Input, NgZone, OnInit, ViewChild } from '@angular/core';
import { AuthService } from 'src/app/_provider/auth.service';
import { GeneralService } from 'src/app/_provider/general.service';
import { SocketMessageData, SocketUser, SocketsService } from 'src/app/_provider/sockets.service';

@Component({
    selector: 'app-socket-ticket-users',
    templateUrl: './socket-ticket-users.component.html',
    styleUrls: ['./socket-ticket-users.component.scss'],
    standalone: false
})
export class SocketTicketUsersComponent implements OnInit {

  @Input() public user: SocketUser
  public hover: boolean = false
  public chatOpen: boolean = false

  public chatInput: string = ""

  @ViewChild("msgtextarea", {static: false}) msgtextarea: any

  constructor(
    private authSrv: AuthService,
    private ngZone: NgZone,
    private socketSrv: SocketsService
  ) { }

  ngOnInit() {
    this.socketSrv.registerHandler("TicketMessage", (data: SocketMessageData<string>)=>{
      if(data.sender == this.user.connectionId){
        this.ngZone.run(()=>{
          this.user.chat.push({message: data.data, timestamp: new Date(), fromSelf: false, fullname: this.user.fullName})
          this.chatOpen = true
        })
      }
    }) 
  }

  ngOnDestroy(){
    this.socketSrv.removeHandler("TicketMessage")
  }

  public auto_grow(element) {
    element.style.height = "5px";
    element.style.height = (element.scrollHeight) + "px";
  }

  public async sendChatMessage(){
    if(!this.chatInput) return
    const selfUser = this.authSrv.getUser()
    this.user.chat.push({message: this.chatInput, timestamp: new Date(), fromSelf: true, fullname: `${selfUser?.firstName} ${selfUser?.lastName}`})
    await this.socketSrv.invoke("SendTicketMessage", this.user.connectionId, this.chatInput)
    this.chatInput = ""
  }

  public startChat(){
    this.ngZone.run(()=>{
      this.chatOpen = true
      setTimeout(() => this.msgtextarea.nativeElement.focus(), 300);
    })
  }
}
